module.exports = __webpack_public_path__ + "static/media/qris.589106bc.svg";